export default "__VITE_ASSET__C6m90Aq4__"